import React, { useState, useEffect } from "react";
import { Box, Typography, keyframes, styled } from "@mui/material";

// Custom styled components with animations
const LogoScreen = styled(Box)({
  position: "fixed",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  background: "#000000ff",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 9999,
});

const LogoAnimation = styled(Box)({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  gap: "30px",
});

const CoinContainer = styled(Box)({
  perspective: "1000px",
  width: "200px",
  height: "200px",
  position: "relative",
});

const Coin = styled(Box)({
  width: "100%",
  height: "100%",
  position: "relative",
  transformStyle: "preserve-3d",
  animation: `${keyframes`
    0% {
      transform: rotateY(0deg);
    }
    50% {
      transform: rotateY(180deg);
    }
    100% {
      transform: rotateY(360deg);
    }
  `} 5s ease-in-out infinite`,
});

const CoinSide = styled(Box)({
  position: "absolute",
  width: "100%",
  height: "100%",
  backfaceVisibility: "hidden",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  borderRadius: "10%",
  background: " #fff",
  boxShadow: "0 8px 25px rgba(45, 134, 89, 0.3)",
  border: "3px solid rgba(255, 255, 255, 0.3)",
});

const CoinFront = styled(CoinSide)({
  transform: "rotateY(0deg)",
});

const CoinBack = styled(CoinSide)({
  transform: "rotateY(180deg)",
});

const CoinLogo = styled("img")({
  width: "150px",
  height: "150px",
  objectFit: "contain",
  filter: "drop-shadow(0 4px 8px rgba(0, 0, 0, 0.2))",
});

const LogoText = styled(Typography)({
  fontSize: "2rem",
  fontWeight: 700,
  color: "#fff",
  shadow: "2.5 ",
  letterSpacing: "2px",
  textAlign: "center",
  animation: `${keyframes`
    from {
      opacity: 0;
      transform: translateY(20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  `} 1s ease-out 0.5s both`,
});

const Flip = ({ onFlipEnd }) => {
  const [showLogo, setShowLogo] = useState(true);
  const [currentLogo, setCurrentLogo] = useState("punjab");

  useEffect(() => {
    // Show Punjab logo for 3 seconds
    const punjabTimer = setTimeout(() => {
      setCurrentLogo("cop30");
    }, 3000);

    // Show COP30 logo for 3 seconds
    const cop30Timer = setTimeout(() => {
      setCurrentLogo("both");
    }, 6000);

    // Hide logo screen and call onFlipEnd after total 6 seconds
    const hideLogoTimer = setTimeout(() => {
      setShowLogo(false);
      if (onFlipEnd) {
        onFlipEnd();
      }
    }, 6000);

    return () => {
      clearTimeout(punjabTimer);
      clearTimeout(cop30Timer);
      clearTimeout(hideLogoTimer);
    };
  }, [onFlipEnd]);

  return (
    <Box
      sx={{
        minHeight: "100vh",
        fontFamily: "Segoe UI, Tahoma, Geneva, Verdana, sans-serif",
      }}
    >
      {/* Logo Animation Screen */}
      {showLogo && (
        <LogoScreen>
          <LogoAnimation>
            <CoinContainer>
              <Coin>
                <CoinFront>
                  <CoinLogo
                    src="/images/PunjabLogo.png"
                    alt="Government of Punjab Logo"
                  />
                </CoinFront>
                <CoinBack>
                  <CoinLogo src="/images/COP30Logo.png" alt="COP30 Logo" />
                </CoinBack>
              </Coin>
            </CoinContainer>

            <LogoText variant="h2">
              {currentLogo === "punjab" && "Government of Punjab"}
              {currentLogo === "cop30" && "COP30 Brazil Amazonia"}
            </LogoText>
          </LogoAnimation>
        </LogoScreen>
      )}
    </Box>
  );
};

export default Flip;